var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmarkAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.286 0C17.872 0 19 1.608 19 3.444l.001 1.605A2.566 2.566 0 0 0 18.5 5l-.158.005c-.116.007-.23.022-.343.044L18 3.444l-.004-.173C17.933 2.006 17.188 1 16.286 1H7.714l-.122.006c-.885.09-1.583 1.152-1.583 2.438L6 23l6-3.667L18 23l-.001-7.05c.163.033.331.05.501.05l.158-.005c.116-.007.23-.022.343-.044L19 23a1 1 0 0 1-1.521.853l-5.48-3.348-5.478 3.348a1 1 0 0 1-1.515-.739L5 23l.009-19.556C5.009 1.606 6.127 0 7.714 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7c.245 0 .45.155.492.359l.008.079V10h2.5a.5.5 0 0 1 .09.992L21.5 11H19v2.563c0 .241-.224.437-.5.437-.245 0-.45-.155-.492-.359L18 13.562V11h-2.5a.5.5 0 0 1-.09-.992L15.5 10H18V7.437c0-.241.224-.437.5-.437Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarkAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bookmark-add.be5607c1d81fbcbe210a03a8b264f234.svg";